/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Loading_TextInputs */



/**
* | output |
* | --- |
* | "Loading presets..." |
*
* @param {Preset_Manager_Loading_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_loading_text = /** @type {((inputs?: Preset_Manager_Loading_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Loading_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des presets...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellungen werden geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento preset in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка предустановок...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando ajustes preestablecidos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载预设……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट लोड हो रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando predefinições...")
	return /** @type {LocalizedString} */ ("Loading presets...")
});